module.exports = __webpack_public_path__ + "static/media/theme_song.73c75bb7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/theme_song.mp3
// module id = 87
// module chunks = 0